export const cleanCurrencyString = (val: string) => {
  let cleanedValue = val
    .trim()
    .replace(/,/g, ".")
    .replace(/^0{2,1000}/g, "0");

  if (
    cleanedValue.length > 0 &&
    !cleanedValue.includes(".") &&
    !isNaN(parseFloat(cleanedValue))
  ) {
    // Only add .00 if is actually a valid number and not already has decimals
    cleanedValue += ".00";
  }
  return cleanedValue;
};
